/**
 * Debug mode — opt-in via the ``?debug=1`` query string.
 *
 * When on, the header swaps its "New session" / "Share session" buttons
 * for a dropdown that lists every live session on the server, letting
 * the operator hop between them. Read once at module load: the flag is
 * carried in the URL and the URL-sync in ``App.tsx`` preserves the
 * ``debug`` param across session changes, so it stays sticky.
 */
export const isDebugMode = (): boolean =>
  new URLSearchParams(window.location.search).get("debug") === "1";
